import { zipSync } from 'fflate';
import { saveAs } from 'file-saver';
import { buildPdfDefinitionFromJson } from 'modules/add-agent/pdf-utils/generateReports';
import { PDF_FILE_NAME_VALIDATE_AGENT, ZIP_FILE_NAME_VALIDATE_AGENT } from 'modules/add-agent/pdf-utils/pdfConstants';
import pdfMake from 'pdfmake/build/pdfmake';

/**
 * Handles the download of the agent deployment report as a ZIP file.
 * The ZIP contains both a PDF and a TXT version of the report.
 * @param {Object} params - The parameters for the download.
 * @param {Object} params.json - The JSON data for the PDF report.
 * @param {string} params.failedReport - The error details as a string for the TXT file.
 * @param {Function} params.t - The translation function for i18n.
 */
export async function handleDownloadReport({ json, t, agentId, agentName }) {
    let zipContents = {};


    if (json) {
        // Generate the PDF document definition using the utility function
        const docDefinition = buildPdfDefinitionFromJson(json, t, agentId, agentName);

        // Create the PDF blob
        const pdfBlob = await new Promise((resolve) => {
            pdfMake.createPdf(docDefinition).getBlob(resolve);
        });

        // Convert PDF blob to Uint8Array for fflate
        const pdfArray = new Uint8Array(await pdfBlob.arrayBuffer());

        // Initialize zipContents with PDF
        zipContents[PDF_FILE_NAME_VALIDATE_AGENT] = pdfArray;
    }


    // Only create and download ZIP if there's content
    if (Object.keys(zipContents).length > 0) {
        const zipped = zipSync(zipContents);

        // Download the zip
        const zipBlob = new Blob([zipped], { type: "application/zip" });
        saveAs(zipBlob, ZIP_FILE_NAME_VALIDATE_AGENT);
    }
}
